"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "\n  :root {\n    --shadow-1: none;\n    --shadow-2: none;\n    --shadow-3: none;\n    --shadow-4: none;\n  }\n";
